import "flowbite";
import { defineCustomElement } from "vue";

import {addIcons} from "oh-vue-icons";
import {HiCheck, HiX, HiChevronDown, HiChevronRight, GiReceiveMoney} from "oh-vue-icons/icons";


import MainMiniSurvey from './components/MainMiniSurvey.ce.vue'
import MainFullSurvey from './components/MainFullSurvey.ce.vue'

addIcons(
    GiReceiveMoney,
    HiCheck,
    HiChevronDown,
    HiX,
    HiChevronRight,
);

const customMainMiniSurvey = defineCustomElement(MainMiniSurvey);
customElements.define("cost-of-living-mini-survey", customMainMiniSurvey);

const customMainFullSurvey = defineCustomElement(MainFullSurvey);
customElements.define("cost-of-living-full-survey", customMainFullSurvey);